import { render } from "./clientSection.vue?vue&type=template&id=c3d0b472&scoped=true"
import script from "./clientSection.vue?vue&type=script&lang=js"
export * from "./clientSection.vue?vue&type=script&lang=js"

import "./clientSection.vue?vue&type=style&index=0&id=c3d0b472&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3d0b472"]])

export default __exports__